import {
    ViewEncapsulation,
    Component,
    HostBinding,
    ElementRef,
    inject,
    input,
    ChangeDetectionStrategy,
    OnInit,
} from '@angular/core';
import { SizeRange } from '@bazis/shared/models/base.types';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --width: initial; --height: initial; --border-radius: inherit; } :host img { display: block; width: var(--width); height: var(--height); border-radius: var(--border-radius); object-fit: cover; }`,
);

@Component({
    selector: 'bazis-thumbnail',
    template: `
        @if (isLoaded) {
            <img
                [src]="src()"
                [alt]="alt()"
                (error)="isLoaded = false"
            />
        } @else {
            <span part="icon">
                <bazis-icon
                    color="action"
                    [icon]="iconNoImg()"
                    [size]="iconSize()"
                ></bazis-icon
            ></span>
        }
    `,
    // styleUrls: ['thumbnail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false,
})
export class ThumbnailElement implements OnInit {
    public el = inject(ElementRef);

    readonly src = input<string>(undefined);

    readonly alt = input<string>(undefined);

    readonly width = input<number>(undefined);

    readonly height = input<number>(undefined);

    readonly radius = input<number>(undefined);

    readonly iconNoImg = input<string>('picture');

    readonly iconSize = input<SizeRange>(SizeRange.huge);

    @HostBinding('role') get roleElement() {
        return 'img';
    }

    @HostBinding('style') get thumbnailStyle() {
        const radius = this.radius();
        return {
            [`--width`]: this.width() + 'px',
            [`--height`]: this.height() + 'px',
            [`--border-radius`]: radius ? radius + 'px' : '',
        };
    }

    isLoaded = true;

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
